/**
 * Naming an inventory category.
 *
 * The six categories shipped with the system are seeded rows with a `slug`; those are
 * ours, so the dictionary supplies the word and the language toggle moves them. A
 * category the office added has no slug and is shown exactly as they typed it.
 *
 * This is the one place in the portal where a database row is legitimately UI copy, so
 * it is also the one place that needs the distinction spelled out. Everywhere else, a
 * user-visible string comes from the dictionary and nowhere else.
 */

import type { TranslationKey } from '@/i18n';
import type { InventoryCategory } from '@/lib/api';

export function categoryLabel(
  category: Pick<InventoryCategory, 'name' | 'slug'> | null | undefined,
  t: (key: TranslationKey) => string,
): string | null {
  if (!category) return null;
  if (category.slug) return t(`inventory.category_${category.slug}` as TranslationKey);
  return category.name;
}
